import React from 'react';
import { 
    translate,
    List, 
    Datagrid,
    TextInput, 
    TextField,
    Filter,
    DateField,
    CardActions,
    ListButton,
    ShowButton,
    Show,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import BoolNumField from '../controls/BoolNumField'
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
//import jwt_decode from 'jwt-decode';

//var userid = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).id : 0 ;


const styles = {
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
};


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const HistoryActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        {/*
        <ListButton basePath={`/certifications?filter=%7B"user_id"%3A"${props.filterValues.user_id}"%7D&order=DESC&page=1&perPage=25&sort=id`} label="Certification" />
        */ }
        <ListButton 
        component={Link}
                to={{
                    pathname: '/certifications',
                    search: stringify({
                        page: 1,
                        perPage: 25,
                        sort: 'id',
                        order: 'DESC',
                        filter: JSON.stringify({ user_id : props.filterValues.user_id}),
                    }),
                }}
        label = 'Certification List'
        />
    </CardActions>
);


export const QuestionFilter = (props) => (
    <Filter {...props}>
      <TextInput source="exam_name" alwaysOn label="Exam Name" />
      <TextInput source="question" label="Question" />
    </Filter>
  );
  


export const ExamHistoryList = (props) => (
  
    <List
    {...props}
  
    perPage={20}
    sort={{ field: "training_name", order: "ASC" }}
    bulkActionButtons={false}
    title="Exam History"
  >
    <Datagrid>
      <TextField source="training_name" label="Training" />
      <DateField source="exam_date" label="Exam Date" locales="en-us" />
      <BoolNumField  source="ispass" label="Pass/Fail" />
      <ShowButton label="View Exam"/>
    </Datagrid>
  </List>
);


export default withStyles(listStyles)(ExamHistoryList)